import {createContext, useContext, useState} from "react";
import axios from "axios";

import {SITES_ROUTE} from "../lib/routes";

export const AuthContext = createContext();

const REACT_APP_API_BASE_URL = (window._env_ && window._env_.API_URL) ? window._env_.API_URL + '/api/cc/' : process.env.REACT_APP_API_BASE_URL;

export const useProvideAuth = () => {
  const [state, setState] = useState({
    user: JSON.parse(sessionStorage.getItem("CloudControl_user")),
    sessionToken: sessionStorage.getItem("CloudControl_sessionToken"),
    sessionExpired: false,
    returnsTo: undefined,
  });

  const login = async ({username, password}) => {
    try {
      const {data: {data}} = await axios.post(`${REACT_APP_API_BASE_URL}login`, {
        username,
        password,
      });
      sessionStorage.setItem("CloudControl_sessionToken", data.token);
      sessionStorage.setItem("CloudControl_user", JSON.stringify({
        id: data.id,
        username: data.username,
      }));
      setState({
        ...state,
        user: {
          id: data.id,
          username: data.username,
        },
        sessionToken: data.token,
        sessionExpired: false,
      });
    } catch (error) {
      if (error.response) {
        const {message} = error.response.data;
        setState({
          ...state,
          user: null,
          sessionToken: null,
          sessionExpired: false,
        });
        throw new Error(message);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
        throw new Error("Ops! Qualcosa è andato storto per favore controlla la tua connessione internet o riprova più tardi.");
      }
    }
  }

  const logout = (
    {
      sessionExpired = false,
      returnsTo = SITES_ROUTE.path
    } = {}
  ) => {
    setState({
      user: null,
      sessionToken: null,
      sessionExpired,
      returnsTo,
    });
    sessionStorage.removeItem("CloudControl_sessionToken");
    sessionStorage.removeItem("CloudControl_user");
    sessionStorage.removeItem("checkedVariables");
    sessionStorage.removeItem("selectedPeriod");
  };

  return {
    ...state,
    login,
    logout,
  };
}

export const AuthProvider = ({ children }) => {
  const auth = useProvideAuth();

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => {
  return useContext(AuthContext)
}
